import server from "@/views/agent_im/server";

export default {
    namespaced: true,
    state: {
        agentInfo: {
            status: 0, //在线状态
            max_csu: "-",
            agent_id: ""
        },
        historyUserId: "", //显示历史记录id

        currentSession: {}, //当前选中的sessionid
        realTimeSessionList: [],
        historySessoinInfo: {
            page: -1, //-1 初始状态未开始
            status: "start",
            prepage: 20,
            list: []
        },
        messageList: [], //{ list: [], status: "start", session_id } status:start,nomore,loadingend,loading, 随新会话更新存储数据

        windowTip: false,
        socketStatus: 0 //0 未连接  1 正常 2 异常重连中 3,//另外一端推送
    },
    mutations: {
        setAgentInfo(state, agentInfo) {
            state.agentInfo = agentInfo;
        },
        setShowHistoryUserId(state, value) {
            state.historyUserId = value;
        },
        setWindowTip(state, param) {
            state.windowTip = param;
        },
        updateSessionTime(state) {
            state.realTimeSessionList.forEach(item => {
                if (item.last_message.create_time) item.last_message.timeFormat = server.timeFormatFun(item.last_message.create_time, true);
            });
        },
        setCurrentSession(state, { session_id, isRealTime }) {
            state.currentSession =
                (isRealTime ? state.realTimeSessionList : state.historySessoinInfo.list).filter(item => item.id == session_id)[0] || {};
        },
        setHistoryList(state, { list, page }) {
            let { prepage, list: listPre } = state.historySessoinInfo;
            listPre.push(...list);
            state.historySessoinInfo = {
                page,
                prepage,
                status: list.length < prepage ? "nomore" : "loadingend",
                list: listPre
            };
        },
        resetHistoryList(state) {
            state.historySessoinInfo = { page: -1, status: "start", prepage: 20, list: [] };
        },
        setRealTimeSessionList(state, { list, session, type, id }) {
            //数组处理应该合并 稍后优化  此处初始化
            switch (type) {
                case "init":
                    list.forEach((item, index) => {
                        list[index] = server.formatSession(item);
                        state.messageList.push({ list: [], status: "start", session_id: item.id }); //有新会话的同时一定有新消息
                    });
                    state.realTimeSessionList = list;
                    break;
                case "add":
                    let index = state.realTimeSessionList.$imFindIndexByKey('id',session.id);
                    if(index==-1){ //去重
                        state.realTimeSessionList.push(server.formatSession(session));
                        state.messageList.push({ list: [], status: "start", session_id: session.id }); //新会话的同时初始化消息列表
                    }
                    break;
                case "delete":
                    if (id == state.currentSession.id) {
                        state.currentSession = {};
                    }
                    let i = state.realTimeSessionList.$imFindIndexByKey("id", id);
                    i > -1 ? state.realTimeSessionList.splice(i, 1) : "";
                    let iMsg = state.messageList.$imFindIndexByKey("session_id", id);
                    i > -1 ? state.messageList.splice(iMsg, 1) : "";
                    break;
            }
        },
        setMessage(state, { list, message, type, session_id }) {
            let { is_send } = message;
            state.realTimeSessionList.forEach((item, index) => {
                if (item.id == message.session_id) {
                    if (state.currentSession.id != session_id && !is_send) {
                        //当前窗口 不加 用户发来的才加
                        item.msg_unread_count++;
                    }
                    item.last_message = message;
                    state.realTimeSessionList[index] = server.formatSession(item);
                }
            });
            let listInfo = state.messageList.filter(item => item.session_id == session_id)[0];
            switch (type) {
                case "add":
                    listInfo.list.push(server.messageFormat(message));
            }
            return true;
        },
        setStatus(state, value) {
            state.agentInfo.status = value;
        },
        setSocketStatus(state, value) {
            state.socketStatus = value;
        }
    },
    actions: {
        async initAgentInfo({ commit }) {
            let agentInfo = await server.getAgentInfo();
            commit("setAgentInfo", agentInfo);
        },
        async showMessageHistory({ commit }, session_id) {
            commit("setShowHistoryUserId", session_id);
        },
        async setCurrentSession({ commit }, { session_id, isRealTime }) {
            commit("setCurrentSession", { session_id, isRealTime });
            commit("setShowHistoryUserId", ""); //切换的时候隐藏历史
        },
        async initRealTimeSessoinList({ commit, state }) {
            let list = await server.getRealTimeSessionList();
            commit("setRealTimeSessionList", { list, type: "init" });
        },
        setWindowTip({ commit }, flag) {
            commit("setWindowTip", flag);
        },

        async getHistorySessionList({ commit, state }, { isReFresh = false } = {}) {
            if (isReFresh) {
                commit("resetHistoryList");
            }
            let { page, prepage, status } = state.historySessoinInfo;
            if (status == "loading" || status == "nomore") {
                return;
            }
            state.historySessoinInfo.status = "loading";
            page += 1;
            let list = await server.getHistorySessionList({ page, agent_id: state.agentInfo.agent_id, prepage });
            commit("setHistoryList", { list, page });
        },
        async finishSession({ commit, dispatch }, session_id) {
            let isSus = await server.closeSession(session_id);
            /*if (isSus) { socket触发
                dispatch("setInfoCenter", { eventType:'AgentImEvent_Session_Closed',content:{ id: session_id },fromSocket:false });
            }*/
        },
        updateSessionTime({ commit }) {
            commit("updateSessionTime");
        },
        //socket 回调
        setInfoCenter({ commit, dispatch, state }, param) {
            let { eventType, content, fromSocket } = param;
            console.log(eventType, content, fromSocket);
            switch (eventType) {
                case "AgentImEvent_Login":
                    commit("setStatus", content.status);
                    break;
                case "AgentImEvent_Logout": //微信IM坐席签出
                    commit("setStatus", content.status);
                    break;

                case "AgentImEvent_Message_Receive": {
                    commit("setMessage", { message: content, type: "add", session_id: content.session_id });
                    break;
                }
                case "AgentImEvent_Session_Transfer_In":
                    content.new_transfer = true;
                case "AgentImEvent_Session_Add":
                    commit("setRealTimeSessionList", { type: "add", session: content });
                    /*  if (state.windowTip) {
                        server.windowTip({
                            content: `来自${content.username}的新会话`,
                            clickcb: () => {
                                this.commit("setCurrentSession", { session_id: content.id, isRealTime: true });
                            }
                        });
                    }*/
                    break;
                case "AgentImEvent_Session_Transfer_Out":
                    if (content.id == state.currentSession.id) {
                        commit("setCurrentSession", { session_id: -1 });
                    }
                    commit("setRealTimeSessionList", { type: "delete", id: content.id });
                    dispatch("getHistorySessionList", { isReFresh: true });
                    break;
                case "AgentImEvent_Session_Closed":
                    commit("setRealTimeSessionList", { id: content.id, type: "delete" });
                    dispatch("getHistorySessionList", { isReFresh: true });
                    break;
                case "AgentImEvent_Session_Close_Fail": {
                    /*     const idlist = content.session_list;
                    const errlist = "";
                    idlist &&
                        idlist.forEach(item => {
                            state.$sessionList.forEach(session => {
                                if (item == session.id) {
                                    errlist.push(item.remark_name);
                                }
                            });
                        });
                    state.$msgInfo.push({ message: errlist.join(",") + "会话删除失败", title: "会话删除失败", type: "error" });
                    break;*/
                }
                case "SOCKET_CLOSE":
                    commit("setSocketStatus", 2);
                    break;
                case "SOCKET_OPEN":
                    commit("setSocketStatus", 1);
                    break;
                case "AgentEvent_WebSocket_Closed":
                    commit("setSocketStatus", 3);
            }
        }
    }
};
